import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "loading-container"
};
import constants from '@/constants';
import { useLess } from '@/models/hooks';
export default {
  __name: 'Loading',
  setup(__props) {
    useLess('components/loading.less');
    const {
      IMAGE_URL
    } = constants;
    // import picture
    const loadingImg = `${IMAGE_URL}assets/image/amzLoading.png`;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        src: loadingImg,
        alt: ""
      })]);
    };
  }
};